"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableCards = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@wordpress/components");
var react_1 = require("react");
var icon_1 = require("../../elements/icon/icon");
var icon_type_1 = require("../../elements/icon/icon-type");
var drag_container_1 = require("../drag-container/drag-container");
var draggable_box_1 = require("../drag-container/draggable-box/draggable-box");
var sortable_cards_style_1 = require("./sortable-cards-style");
function SortableCards(props) {
    var items = props.items, selectedItemId = props.selectedItemId, menuItems = props.menuItems, onSelectedItemChange = props.onSelectedItemChange;
    var _a = (0, react_1.useState)([]), stateItems = _a[0], setStateItems = _a[1];
    var onDragEnd = function (result) {
        var source = result.source, destination = result.destination;
        if (!destination) {
            return;
        }
        var newItems = Array.from(stateItems);
        var removed = newItems.splice(source.index, 1)[0];
        newItems.splice(destination.index, 0, removed);
        setStateItems(newItems);
    };
    (0, react_1.useEffect)(function () {
        setStateItems(items);
    }, [items]);
    return ((0, jsx_runtime_1.jsx)(drag_container_1.DragContainer, { droppableId: "droppable", onDragEnd: onDragEnd, children: (0, jsx_runtime_1.jsx)(sortable_cards_style_1.StyledListContainer, { children: stateItems.map(function (item, index) {
                var id = item.id, title = item.title, badge = item.badge;
                var isSelected = selectedItemId === id;
                return ((0, jsx_runtime_1.jsx)(draggable_box_1.DraggableBox, { draggableId: id, index: index, children: (0, jsx_runtime_1.jsxs)(sortable_cards_style_1.StyledListItem, { selected: isSelected, onClick: function () {
                            onSelectedItemChange === null || onSelectedItemChange === void 0 ? void 0 : onSelectedItemChange(id);
                        }, children: [(0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.DRAG }), (0, jsx_runtime_1.jsx)(sortable_cards_style_1.StyledListItemTitle, { children: title }), badge ? (0, jsx_runtime_1.jsx)(sortable_cards_style_1.StyledListItemBadge, { selected: isSelected, children: badge }) : null, menuItems ? ((0, jsx_runtime_1.jsx)(components_1.DropdownMenu, __assign({}, menuItems, { icon: (0, jsx_runtime_1.jsx)(icon_1.Icon, { iconName: icon_type_1.IconName.MORE_VERTICAL }), on: true }))) : null] }) }, id));
            }) }) }));
}
exports.SortableCards = SortableCards;
